<template>
  <ul :id="`tree-node-actions-${nodo.id}`">
    <li>
      <a
        class="a-tooltip-primary a-tooltip-bottom"
        :data-tooltip-text="activo
          ? $t('mEditionAssetContentsTreeNodeStudentState.tooltips.activeTrue')
          : $t('mEditionAssetContentsTreeNodeStudentState.tooltips.activeFalse')"
        href="#"
        @click.prevent="updateInscripcionNodoEstado"
      >
        <i
          v-if="showLoadingIcon"
          class="fas fa-spinner fa-spin node-icon-loading"
        >
        </i>
        <i
          v-else
          :class="activo ? 'far fa-check text-color-success' : 'far fa-times'">
        </i>
      </a>
    </li>
    <li>
      <a
        class="a-tooltip-primary a-tooltip-bottom inactive-action"
        :data-tooltip-text="visto
          ? $t('mEditionAssetContentsTreeNodeStudentState.tooltips.seenTrue')
          : $t('mEditionAssetContentsTreeNodeStudentState.tooltips.seenFalse')"
      >
        <i :class="visto ? 'far fa-eye text-color-info' : 'far fa-eye-slash'"></i>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetContentsTreeNodeStudentState',

  props: {
    contenido: Object,
    nodo: Object,

    info: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      activo: false,
      showLoadingIcon: false,
      visto: false
    }
  },

  watch: {
    'info.nodosActivos': {
      deep: true,

      handler () {
        this.setNodoEstados()
      }
    }
  },

  created () {
    this.setNodoEstados()
  },

  methods: {
    setNodoEstados () {
      let nodoActivo = this.info.nodosActivosInscripcion.find(nodo => nodo.nodo === this.nodo.id)
      this.activo = nodoActivo !== undefined
      this.visto = nodoActivo !== undefined ? nodoActivo.visto : false
    },

    updateInscripcionNodoEstado () {
      if (!this.showLoadingIcon) {
        this.showLoadingIcon = true
        this.$services.update('inscripcion', 'updateInscripcionNodoEstado', { 'nodos': [this.nodo.id] }, [this.$route.params.subid])
          .then(response => {
            this.activo = !this.activo
            this.$modal.updateData()
            this.$alerts.pushAlert('mEditionAssetContentsTreeNodeStudentState', 'updateInscripcionNodoEstado', this.activo ? 'activationSuccess' : 'deactivationSuccess')
            this.showLoadingIcon = false
          })
          .catch(error => {
            console.log(error)
            this.showLoadingIcon = false
            this.$alerts.pushAlert('mEditionAssetContentsTreeNodeStudentState', 'updateInscripcionNodoEstado', 'error', 'a-alert-danger')
          })
      }
    }
  }
}
</script>
